import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/magnumbet/images/racing/mysteryBetLogo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 1,
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'odds', h: '38px', borderRadius: 'md' },
  imageLogo: {
    w: '250px',
    src: mysteryLogo,
    mt: '2',
  },
  iconMystery: {
    mb: '1',
  },
  textSlash: {
    color: 'whiteAlpha.400',
    fontWeight: 'bold',
    fontSize: '2xs',
  },
  flexWrapperMysteryLabelView: {
    color: 'white',
    fontFamily: 'accent',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'bold',
    gap: 1,
    lineHeight: 'normal',
    alignItems: 'center',
    sx: {
      '&&': {
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  buttonAddToBetslip: {
    variant: 'odds',
    sx: {
      '&&': {
        borderLeftRadius: 'none',
        borderRightRadius: 'md',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        ms: '0',
        fontSize: 'xs',
      },
      _disabled: {
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
        opacity: 1,
        color: 'beta.300',
        pointerEvents: 'none',
        _before: {
          display: 'none',
        },
      },
    },
  },
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    gap: '2',
    bg: 'alpha.300',
    borderRadius: 'md',
    borderRightRadius: 'none',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: ['2xs', null, 'xs'],
    fontFamily: 'accent',
    fontWeight: 'bold',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    lineHeight: 'normal',
    sx: {
      '&&': {
        px: [2, 3],
        svg: {
          mb: '0.5',
        },
      },
    },
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'alpha.300',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    px: '3',
    py: '1',
    overflow: 'hidden',
    mx: 'auto',
  },
  flexWrapperMysteryPlacedBetView: {
    fontWeight: 'normal',
    textShadow: 'none',
    fontStyle: 'normal',
  },
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    w: 'full',
    gap: '2',
    mt: '3',
    bg: 'alpha.600',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    gap: '2',
    bg: 'alpha.600',
    borderRadius: 'md',
    p: '2',
    mt: '3',
    transition: '.3s ease-in-out',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'alpha.700',
    boxShadow:
      '0px 3px 4px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 1px rgba(252, 211, 96, 1) inset',
    borderRadius: 'md',
    boxSize: '10',
    p: '0',
    w: '38px',
    h: '38px',
    color: 'beta.300',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)',
    cursor: 'pointer',
  },
  flexWrapperWithTooltip: {
    gap: 1,
  },
  imageMysteryBet: {
    w: '5',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    fontSize: '2xs',
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: 'uppercase',
    textShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  textPriceInfo: {
    fontSize: ['2xs', null, 'xs'],
    color: 'beta.300',
    fontFamily: 'accent',
    fontWeight: 'bold',
    fontStyle: 'normal',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  textRollover: {
    fontSize: ['2xs', null, 'xs'],
    color: 'beta.300',
    fontFamily: 'accent',
    fontWeight: 'bold',
    textShadow: 'none',
    fontStyle: 'normal',
    textTransform: 'uppercase',
  },
  textError: {
    color: 'white',
    fontFamily: 'accent',
    fontWeight: 'normal',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontStyle: 'normal',
    fontSize: ['2xs', null, 'xs'],
  },
  iconBack: {
    boxSize: '7',
    color: 'white',
  },
  iconRace: { color: 'beta.300', mb: '2' },
  textSpanWhite: {
    color: 'white',
    textTransform: 'capitalize',
    fontFamily: 'accent',
    fontWeight: 'bold',
  },
  buttonRollOver: {
    variant: 'outline',
    borderRadius: 'md',
    h: '7',
    px: '2',
    color: 'beta.300',
    _disabled: {
      bg: 'blackAlpha.500',
      boxShadow:
        '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
      color: 'beta.300',
      textShadow: 'none',
      border: 'none',
      _before: {
        display: 'none',
      },
    },
  },
  spanSelectionText: {
    color: 'beta.300',
    textTransform: 'uppercase',
    fontFamily: 'accent',
    fontWeight: 'bold',
  },
  spanPositionType: {
    color: 'beta.300',
    textTransform: 'capitalize',
    fontFamily: 'accent',
    fontWeight: 'bold',
  },
  tooltipIcon: {
    color: 'beta.300',
    fill: 'beta.300',
  },
  buttonGroupAddToBetslip: {
    mr: '1',
    alignItems: 'center',
    maxW: ['250px', null, 'unset'],
  },
  motionLeftToRight: {
    sx: {
      '&&': {
        '> div': {
          gap: '0',
        },
      },
    },
  },
  flexWrapperPlacedBetViewGroup: { mb: '2' },
};
